import N8nRadioGroup from './RadioGroup.vue';

export default N8nRadioGroup;
export type { RadioGroupOption } from './RadioGroup.vue';
